export default function initScrollReveal($) {
  /* ========================================================================= *\
  **  === Scrollreveal                                                   *| 
  \* ========================================================================= */
  
  
  if ($(window).width() < 992) {
    ScrollReveal().reveal('.reveal', {
      interval: 0,
      duration: 1000,
      // reset: true,
    });
  } else {
    ScrollReveal().reveal('.reveal', {
      interval: 300,
      duration: 2000,
      // reset: true,
      // beforeReveal: function(el) {
      //   if($('.picto-deco')) {
      //     KUTE.fromTo('.picto-deco svg *',{draw:'0% 0%'}, {draw:'0% 100%'}, {duration: 80000}).start();
      //   }
      // }
    });
  };

  ScrollReveal().reveal('.reveal--top', {  
    origin: 'top',
    distance: '50px',
  });

  ScrollReveal().reveal('.reveal--bottom', {  
    origin: 'bottom',
    distance: '50px',
  });

  ScrollReveal().reveal('.reveal--left', {  
    origin: 'left',
    distance: '50px',
  });

  ScrollReveal().reveal('.reveal--right', {  
    origin: 'right',
    distance: '50px',
  });
  
  ScrollReveal().reveal('.reveal--reset', { 
    reset: true,
  });  


  
}
